module.exports = __webpack_public_path__ + "static/img-subfooter-pharmacists-4d82a4b1e0b84bd9b4d233703e527ac8.jpg";